import { forwardRef, ReactNode } from 'react';

import clsx from 'clsx';

import classes from './Page.module.scss';

export interface PageProps {
  actions?: ReactNode;
  children: ReactNode;
  testId?: string;
  fullscreen?: boolean;
  isSidesheetOpened?: boolean;
  fixed?: boolean;
  contentClassName?: string;
}

export const Page = forwardRef<HTMLDivElement, PageProps>(function Inner(
  {
    actions,
    children,
    fullscreen,
    isSidesheetOpened,
    testId,
    fixed,
    contentClassName,
  },
  ref,
) {
  return (
    <div
      className={clsx(
        classes.container,
        !fixed && classes.regular,
        fullscreen && classes.fullscreen,
        fullscreen && isSidesheetOpened && classes.fullscreenWithSidesheet,
      )}
      data-testid={testId}
      ref={ref}
    >
      {actions}
      <div className={clsx(classes.content, contentClassName)}>{children}</div>
    </div>
  );
});
